import React, { useEffect, useState } from "react";
import { Alert, AlertTitle, Link, Typography, Divider, Grid, Button } from "@mui/material";
import { Redirect, useHistory } from "react-router";
import queryString from "query-string";

export function OptInBookingInvalid(props) {
  const { push } = useHistory()

  const [reasonText, setReasonText] = useState(null)
  
    //Get reason for invalid
    const value = queryString.parse(window.location.search);
    const reason = value.reason;

    useEffect(() => {
      switch(reason){
        case "expired":
          setReasonText({
            "title": "You are no longer valid for opt in booking.",
            "explanation": "Due to your last appointment with us at Connect Health being more than 28 days ago, we are afraid we can no longer off you the ability to request another appointment."
          })
          break;

        case "invalid":
          setReasonText({
            "title": "You are not valid for opt in booking.",
            "explanation": "We are afraid that we are unable to offer you the ability to request an appointment."
          })
          break;

        case "alreadyRequested":
          setReasonText({
            "title": "You have already requested an appointment.",
            "explanation": "We will contact you with an offer for the earliest available appointment."
          })
          break;

        default: 
        setReasonText({
          "title": "You are not valid for opt in booking or we could not find your details.",
          "explanation": "We apologise for any inconvenience, if this is an error then please contact us. https://www.connecthealth.co.uk/contact/"
        })
        break;
      }
      
    },[])

  return (
    <Grid container align="center" alignItems="center" justifyContent="center" direction="column">
      {reasonText != null &&
        <Alert
          severity="error"
          variant="filled"
          sx={{
            mt: {
              xs: 3,
              sm: 2,
            },
            mb: 2,
            maxWidth: "md"
          }}
        >
          <AlertTitle>{reasonText["title"]}</AlertTitle>
          <br />
          <Typography>
            {" "}
            {reasonText["explanation"]}
          </Typography>
          <br />
          <br />
          <Divider/>
          <br />
          <Typography>
            {" "}
            If you need to, you can get in touch with us through our website -{" "}
            <Link
              href="https://www.connecthealth.co.uk/contact/"
              target="_blank"
              rel="noopener"
              color="inherit"
              underline="always"
            >
              https://www.connecthealth.co.uk/contact/
            </Link>
          </Typography>
          <Typography>
            You will also find information about your service, including opening
            times, services offered and who your clinicians are, on our website.
          </Typography>
          <br />
          {
            reason == 'notFound' &&
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{maxWidth: "md"}} >
              <Button
                  sx={{ margin:"40px 0px 10px 10px" }}
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => push(`/Booking/Validate`)}
              >
                  {"Try again"}
              </Button>
          </Grid>
        }
        </Alert>
      }
    </Grid>
  );
}
